import { GROUP_COLORS } from '../../constants';

export const groupColorMap = GROUP_COLORS.colorMap;

export const getGroupColorByCSSClass = (cssClass) => {
    if (/^(#|rgba?\(|hsla?\(|var\()/.test(cssClass)) return cssClass;

    return groupColorMap[cssClass] || groupColorMap['.groupColorUngrouped'];
};

export const getGroupColorCssClasses = () => GROUP_COLORS.colorClasses;
